import * as React from 'react'
import { Job } from '../types'
import JobUtils from '../utils/JobUtils'
import ListItem from '@material-ui/core/ListItem'
import { Avatar, ListItemText, ListItemSecondaryAction } from '@material-ui/core'
import '../styles/CompletedJobsList.scss'

import moment from 'moment'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'
import {getFormatedPrice} from '../utils/PricingUtils'
import {FlatButton} from "material-ui";
import {ROUTES} from '../constants/routes';
import {RouterAction} from 'react-router-redux';
import {LocationDescriptor} from 'history';
import {ContactUsType} from '../types/ContactUs';

interface Props {
  job: Job
  id: number
  showCompletedJob: (job: Job) => void
  routePush: (location: LocationDescriptor) => RouterAction
}

export class CompletedJobsListItem extends React.Component<Props, {}> {
  private readonly bigHome = require('../styles/icons/building/big-home.png')
  private readonly home = require('../styles/icons/building/private-home.png')

  constructor(props: any) {
    super(props)
  }

  formatDate = (dateFrom: number, dateTo: number): string => {
    if (dateFrom === undefined || dateTo === undefined) {
      return ''
    }
    if (dateFrom === dateTo) {
      return `${moment(this.props.job.futureDateFrom).format('MM/DD/YYYY')} ${StringResources.getString(Strings.Components.CompletedJobDetailed.Text.Latest)} ${moment(this.props.job.futureDateFrom).format('h:mm A')}`
    }
    return moment(this.props.job.futureDateTo).format('MM/DD/YYYY h:mm A')
  }

  _onItemClick = () => {
    this.props.showCompletedJob(this.props.job)
  }

  render() {
    let job = this.props.job
    let bags
    if (job && job.jobItems) {
      job.jobItems.map((subcategory, indexSubCategory) => {
        if (indexSubCategory === 0) {
          bags = `${subcategory.count} ${subcategory.subCategoryId}`
        } else {
          bags = `${bags}, ${subcategory.count} ${subcategory.subCategoryId}`
        }
      })
    }
    let jobCategoryName = JobUtils.getJobCategoryName(job)
    let date = this.formatDate(job.futureDateFrom as number, job.futureDateTo as number)
    let address
    if (job.address) {
      address = `${job.address.city}, ${job.address.region} ${job.address.zipCode}`
    }
    let price = JobUtils.getFinalAmount(job);
    return <ListItem key={this.props.id} className="completed-jobs-list-item" onClick={this._onItemClick}>
        <Avatar src={job.apartmentNumber ? this.bigHome : this.home} style={{ borderRadius: 0 }} />
        <ListItemText primary={<div>
              <span>{jobCategoryName}</span>
              {JobUtils.isCancelledJob(job) ? <span> - </span> : ""}
              {JobUtils.isCancelledJob(job) ? <span className="completed-jobs-list-item-cancelled">
                  {StringResources.getString(
                    Strings.Components.CompletedJobDetailed.Text.Cancelled
                  )}
                </span> : ""}
            </div>} secondary={<span>
              <span>{bags}</span>
              <br />
              <span>{date}</span>
              <br />
              <span>{address}</span>
            </span>} />
        <ListItemSecondaryAction className="completed-jobs-list-item-right-element">
          {price ? `$${getFormatedPrice(price)}` : ""}
        </ListItemSecondaryAction>
      </ListItem>;
  }
}



// WEBPACK FOOTER //
// ./src/components/CompletedJobsListItem.tsx